export default __webpack_public_path__ + "static/media/electronics.b4e30742.jpg";